var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14.1666L17.5 9.99997M17.5 9.99997L13.3333 5.8333M17.5 9.99997H7.5M10 14.1666C10 14.413 10 14.5361 9.99084 14.6428C9.89569 15.7516 9.07905 16.664 7.98753 16.881C7.88252 16.9019 7.76001 16.9155 7.51529 16.9427L6.66412 17.0373C5.3854 17.1794 4.74601 17.2504 4.23805 17.0879C3.56078 16.8711 3.00785 16.3762 2.71765 15.727C2.5 15.2401 2.5 14.5968 2.5 13.3102V6.68972C2.5 5.40311 2.5 4.7598 2.71765 4.2729C3.00785 3.6237 3.56078 3.12881 4.23805 2.91208C4.74601 2.74953 5.38538 2.82057 6.66412 2.96265L7.51529 3.05723C7.7601 3.08443 7.8825 3.09803 7.98753 3.11891C9.07905 3.33593 9.89569 4.24834 9.99084 5.35714C10 5.46383 10 5.58699 10 5.8333",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7bcb9ee867c17754efa39fffd624ece6.svg";
export { ForwardRef as ReactComponent };